import Vue from 'vue'
import Router from 'vue-router'
const Index = ()=> import('@/pages/index/index')
const Production = ()=> import('@/pages/production/index')
const Skill = ()=> import('@/pages/skill/index')
const Information =()=> import('@/pages/information/index')
const informationDetail =()=> import('@/pages/information/detail')
const About = ()=> import('@/pages/about/index')
const AboutIntroduce = ()=> import('@/pages/about/introduce')
const AboutCalture = ()=> import('@/pages/about/calture')
const AboutDeve = ()=> import('@/pages/about/development')
const Concat = ()=> import('@/pages/concat/index')
const ConcatWay = ()=> import('@/pages/concat/way')
const ConcatSuggest = ()=> import('@/pages/concat/suggest')
Vue.use(Router)

let Route = new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
        path: '/index',
        component: Index,
        meta: {
            title: "日基华精密机械-服务全球 高端制造",
            keywords: '塑胶模具配件、机械五金零件、冲压模具零件、工厂自动化零件、电子电器零件、非标零件',
            description:'自2002年创业以来，日基华通过独创的严格精密生产和销售方式在工业零件领域实现了行业定制造。日基华公司以“高品质（Quality）、低成本（Cost）、短交期（Time）”和即使是订购一件产品也会准时送达为理念，努力满足顾客的各种不同需求。\
    公司的愿望与使命是通过不断发展“QCT模式”，积极实践战略性经营，成为中国乃至全球制造业的“后盾”。 日基华自2002年7月建立中国宏达精密机械有限公司，后于2006年6月在香港设日华精密国际有限公司，2009年总部设立在中国东莞日基华精密机科有限公司。\
    日基华是一家国际化制造公司，拥有和众多世界知名企业超过10多年的合作经验。凭借先进的技术、设备和优良的管理，一直保持模具标准件行业良好的口碑。我们致力于为您提供量身定制的产品和服务，始终以满足您的需求为目的，不断提供更适合您的专业化解决方案。日基华在中国下设东莞1个生产基地，在香港有日华有限公司。总面积4800平方米，拥有员工200人，主加工设备100余台。现有产品113大类14000种，能完全满足客户的一站式采购，提供最近最贴心的服务。\
    '
        }
    },
    {
        path: '/production',
        component: Production,
        meta: {
            title: "日基华精密机械-产品服务",
            keywords: '塑胶模具配件、机械五金零件、冲压模具零件、工厂自动化零件、电子电器零件、非标零件',
            description:'单节射梢、双节射梢、双节射梢、扁梢、扁梢、定位柱、塑胶模导套、直套、中柱套、塑胶模导套、直套、中托套、定位柱、方型辅助器、立体定位块组导位辅助器、A、B、C型灌嘴、固定圈A、B型、标准型机械式开关器、方型辅助器、小水口标准特殊注口衬套、大水口标准特殊注口衬套、模具日期指示装置、树脂开关器、止水栓、塑胶模具用成品梢、笔心、笔管、小拉杆C型、斜撑梢、拉料梢、塑胶模导柱、拉杆、回针、弹簧、顶针、司筒、垃圾钉等。金属材料、树脂材料、隔热板、陶瓷制品、玻璃&镜子、透明树脂罩、冲孔金属板&栅栏&丝网&天花板、聚氨酯&橡胶&海绵&毡布、丝网、硬质合金立铣刀、高速钢立铣刀、车削刀具、专用铣刀、丝锥、钻头、倒角&定心刀具、铰刀、阶梯钻、电钻钻头、混凝土钻头、开孔器、铣刀、切削工具等。凸模&凹模、导向零件、小零件&外围零件、压力源。直线运动零件、传感器/开关、模块/装置、气动/液压设备、定位/固定零件、温度调节零件、配管零件、弹簧/冲击保护、液压用装置、外装零件、真空零件、调整连结零件、涂装设备、滑台、光学部品、检查用部品、马达/减速机/离合器制动器、轴承/凸轮轴承随动器/旋转零件、联轴器/带轮/传动零件、传送零件等。PLC、变频器、断路器、连接器、电线电缆、多层信号灯、开关按钮、手工具、电动工具、空压工具、测量工具、磨削研磨用品、电火花工具、切断用品、焊接工具、化工产品、修补剂&粘结剂、焊料&静电对策用品、机床工具等。推管&中心销、型芯、浇口套&流道相关、日期章&回收章&排气元件、抽芯相关、导向&推板导向&精定位组件、开模相关零件、冷却&加热相关&小零件及其他、大型模具&压铸模具用零件、油缸、注塑成型工具&辅助器材相关零件等。凸模&凹模、导向零件、小零件&外围零件、压力源等。'
        }
    },
    {
        path: '/skill',
        component: Skill,
        meta: {
            title: "日基华精密机械-技术制造",
            keywords: '日本三丰二次元、日本三丰三次元、日本三丰工具显微镜、铬氏硬度计、瑞士高度尺、高速CNC、CNC.慢走丝.EDM放电机、内处研磨机、外研磨、平面磨',
            description:'单节射梢、双节射梢、双节射梢、扁梢、扁梢、定位柱、塑胶模导套、直套、中柱套、塑胶模导套、直套、中托套、定位柱、方型辅助器、立体定位块组导位辅助器、A、B、C型灌嘴、固定圈A、B型、标准型机械式开关器、方型辅助器、小水口标准特殊注口衬套、大水口标准特殊注口衬套、模具日期指示装置、树脂开关器、止水栓、塑胶模具用成品梢、笔心、笔管、小拉杆C型、斜撑梢、拉料梢、塑胶模导柱、拉杆、回针、弹簧、顶针、司筒、垃圾钉等。金属材料、树脂材料、隔热板、陶瓷制品、玻璃&镜子、透明树脂罩、冲孔金属板&栅栏&丝网&天花板、聚氨酯&橡胶&海绵&毡布、丝网、硬质合金立铣刀、高速钢立铣刀、车削刀具、专用铣刀、丝锥、钻头、倒角&定心刀具、铰刀、阶梯钻、电钻钻头、混凝土钻头、开孔器、铣刀、切削工具等。凸模&凹模、导向零件、小零件&外围零件、压力源。直线运动零件、传感器/开关、模块/装置、气动/液压设备、定位/固定零件、温度调节零件、配管零件、弹簧/冲击保护、液压用装置、外装零件、真空零件、调整连结零件、涂装设备、滑台、光学部品、检查用部品、马达/减速机/离合器制动器、轴承/凸轮轴承随动器/旋转零件、联轴器/带轮/传动零件、传送零件等。PLC、变频器、断路器、连接器、电线电缆、多层信号灯、开关按钮、手工具、电动工具、空压工具、测量工具、磨削研磨用品、电火花工具、切断用品、焊接工具、化工产品、修补剂&粘结剂、焊料&静电对策用品、机床工具等。推管&中心销、型芯、浇口套&流道相关、日期章&回收章&排气元件、抽芯相关、导向&推板导向&精定位组件、开模相关零件、冷却&加热相关&小零件及其他、大型模具&压铸模具用零件、油缸、注塑成型工具&辅助器材相关零件等。凸模&凹模、导向零件、小零件&外围零件、压力源等。'
        }
    },
    {
        path: '/information/:id',
        component: Information,
        children: [
            {
                path: '/information/:id/detail',
                component: informationDetail,
                meta: {
                    title: "日基华",
                    keywords: '塑胶模具配件、机械五金零件、冲压模具零件、工厂自动化零件、电子电器零件、非标零件',
                    description:'自2002年创业以来，日基华通过独创的严格精密生产和销售方式在工业零件领域实现了行业定制造。日基华公司以“高品质（Quality）、低成本（Cost）、短交期（Time）”和即使是订购一件产品也会准时送达为理念，努力满足顾客的各种不同需求。公司的愿望与使命是通过不断发展“QCT模式”，积极实践战略性经营，成为中国乃至全球制造业的“后盾”。 日基华自2002年7月建立中国宏达精密机械有限公司，后于2006年6月在香港设日华精密国际有限公司，2009年总部设立在中国东莞日基华精密机科有限公司。日基华是一家国际化制造公司，拥有和众多世界知名企业超过10多年的合作经验。凭借先进的技术、设备和优良的管理，一直保持模具标准件行业良好的口碑。我们致力于为您提供量身定制的产品和服务，始终以满足您的需求为目的，不断提供更适合您的专业化解决方案。日基华在中国下设东莞1个生产基地，在香港有日华有限公司。总面积4800平方米，拥有员工200人，主加工设备100余台。现有产品113大类14000种，能完全满足客户的一站式采购，提供最近最贴心的服务。'
                }
            }
        ],
        meta: {
            title: "日基华",
            keywords: '塑胶模具配件、机械五金零件、冲压模具零件、工厂自动化零件、电子电器零件、非标零件',
            description:'自2002年创业以来，日基华通过独创的严格精密生产和销售方式在工业零件领域实现了行业定制造。日基华公司以“高品质（Quality）、低成本（Cost）、短交期（Time）”和即使是订购一件产品也会准时送达为理念，努力满足顾客的各种不同需求。公司的愿望与使命是通过不断发展“QCT模式”，积极实践战略性经营，成为中国乃至全球制造业的“后盾”。 日基华自2002年7月建立中国宏达精密机械有限公司，后于2006年6月在香港设日华精密国际有限公司，2009年总部设立在中国东莞日基华精密机科有限公司。日基华是一家国际化制造公司，拥有和众多世界知名企业超过10多年的合作经验。凭借先进的技术、设备和优良的管理，一直保持模具标准件行业良好的口碑。我们致力于为您提供量身定制的产品和服务，始终以满足您的需求为目的，不断提供更适合您的专业化解决方案。日基华在中国下设东莞1个生产基地，在香港有日华有限公司。总面积4800平方米，拥有员工200人，主加工设备100余台。现有产品113大类14000种，能完全满足客户的一站式采购，提供最近最贴心的服务。'
        }
    },
    {
        path: '/about',
        component: About,
        redirect: '/about/introduce',
        children: [
            {
                path: '/about/introduce',
                component: AboutIntroduce,
            },
            {
                path: '/about/calture',
                component: AboutCalture
            },
            {
                path: '/about/development',
                component: AboutDeve
            }
        ],
        meta: {
            title: "日基华精密机械-服务全球 高端制造",
            keywords: '塑胶模具配件、机械五金零件、冲压模具零件、工厂自动化零件、电子电器零件、非标零件',
            description:'自2002年创业以来，日基华通过独创的严格精密生产和销售方式在工业零件领域实现了行业定制造。日基华公司以“高品质（Quality）、低成本（Cost）、短交期（Time）”和即使是订购一件产品也会准时送达为理念，努力满足顾客的各种不同需求。\
    公司的愿望与使命是通过不断发展“QCT模式”，积极实践战略性经营，成为中国乃至全球制造业的“后盾”。 日基华自2002年7月建立中国宏达精密机械有限公司，后于2006年6月在香港设日华精密国际有限公司，2009年总部设立在中国东莞日基华精密机科有限公司。\
    日基华是一家国际化制造公司，拥有和众多世界知名企业超过10多年的合作经验。凭借先进的技术、设备和优良的管理，一直保持模具标准件行业良好的口碑。我们致力于为您提供量身定制的产品和服务，始终以满足您的需求为目的，不断提供更适合您的专业化解决方案。日基华在中国下设东莞1个生产基地，在香港有日华有限公司。总面积4800平方米，拥有员工200人，主加工设备100余台。现有产品113大类14000种，能完全满足客户的一站式采购，提供最近最贴心的服务。\
    '
        }


    },
    {
        path: '/concat',
        component: Concat,
        redirect: '/concat/way',
        children: [
            {
                path: '/concat/way',
                component: ConcatWay,
            },
            {
                path: '/concat/suggest',
                component: ConcatSuggest
            }
        ],
        meta: {
            title: "日基华精密机械-服务全球 高端制造",
            keywords: '塑胶模具配件、机械五金零件、冲压模具零件、工厂自动化零件、电子电器零件、非标零件',
            description:'自2002年创业以来，日基华通过独创的严格精密生产和销售方式在工业零件领域实现了行业定制造。日基华公司以“高品质（Quality）、低成本（Cost）、短交期（Time）”和即使是订购一件产品也会准时送达为理念，努力满足顾客的各种不同需求。\
    公司的愿望与使命是通过不断发展“QCT模式”，积极实践战略性经营，成为中国乃至全球制造业的“后盾”。 日基华自2002年7月建立中国宏达精密机械有限公司，后于2006年6月在香港设日华精密国际有限公司，2009年总部设立在中国东莞日基华精密机科有限公司。\
    日基华是一家国际化制造公司，拥有和众多世界知名企业超过10多年的合作经验。凭借先进的技术、设备和优良的管理，一直保持模具标准件行业良好的口碑。我们致力于为您提供量身定制的产品和服务，始终以满足您的需求为目的，不断提供更适合您的专业化解决方案。日基华在中国下设东莞1个生产基地，在香港有日华有限公司。总面积4800平方米，拥有员工200人，主加工设备100余台。现有产品113大类14000种，能完全满足客户的一站式采购，提供最近最贴心的服务。\
    '
        }
    }
  ]
})
Route.beforeEach((to, from, next) => {
    window.scrollTo(0,0);
    if(to.meta.keywords){
        let head = document.getElementsByTagName('head');
        let meta = document.createElement('meta');
        meta.name = 'keywords';
        meta.content = to.meta.keywords;
        head[0].appendChild(meta)
    }
    if(to.meta.description){
        let head = document.getElementsByTagName('head');
        let meta = document.createElement('meta');
        meta.name = 'description';
        meta.content = to.meta.description;
        head[0].appendChild(meta)
    }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})
export default Route;



// WEBPACK FOOTER //
// ./src/router/index.js